<div class="card">
	<div class="card-header">
		<h1>Administración de Afiliados, Puntos y Eventos</h1>
	</div>
	<div class="card-body">
		<ul class="nav nav-tabs">
			<li class="nav-item" (click)="selected = 'affiliate'">
				<span [class.active]="selected == 'affiliate'" class="nav-link">Afiliados y Puntos</span>
			</li>
			<li class="nav-item" (click)="selected = 'events'">
				<span [class.active]="selected == 'events'" class="nav-link">Eventos</span>
			</li>
			<li class="nav-item" (click)="selected = 'historical'">
				<span [class.active]="selected == 'historical'" class="nav-link">Historial</span>
			</li>
		</ul>
		<ng-container *ngIf="selected == 'affiliate'">
			<div class="table-responsive" style="margin-top: -1px;">
				<table class="table table-bordered" style="margin: 0;">
					<thead>
						<tr>
							<th colspan="7" class="td-center h3">
								Esquema de Puntos Actual
								<i placement="bottom" tooltip="Editar tasa de cambio" class="clickeable text-info fa fa-edit" (click)="modalSchemaShowing = true"></i>
							</th>
						</tr>
						<tr class="all-tds-center">
							<th class="td-center">
								Activo
							</th>
							<th>
								Nombre
							</th>
							<th>
								Quetzales
							</th>
							<th>
								Puntos
							</th>
							<th>
								Efectivo
							</th>
							<th>
								Credito
							</th>
							<th>
								Transferencia
							</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngIf="!schemas">
							<td colspan="7" class="td-center">
								<i class="fa fa-circle-info"></i>Aún no se ha ingresado un esquema, <b class="tag-schema" (click)="modalSchemaShowing = true">ingresa uno</b>
							</td>
						</tr>
						<tr *ngIf="schemas" class="all-tds-center">
							<td class="td-center">
								<i *ngIf="!updatingSchema" tooltip="Activa/Desactiva estado del afiliado"
									(click)="updateSchemaStatus()"
									[ngClass]="schemas.active?'fa-toggle-on text-success':'fa-toggle-off'"
									class="fa active clickeable"></i>
								<span *ngIf="updatingSchema"
									[ngClass]="schemas.active?'text-secondary':'text-success'"
									class="spinner-border spinner-border-sm"></span>
							</td>
							<td>
								{{schemas.nombre}}
							</td>
							<td>
								{{schemas.quetzals | currency:'Q'}}
							</td>
							<td>
								{{schemas.points}}
							</td>
							<td>
								{{schemas.cash | currency:'Q'}}
							</td>
							<td>
								{{schemas.credit | currency: 'Q'}}
							</td>
							<td>
								{{schemas.transfer | currency: 'Q'}}
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="table-responsive" style="margin-top: -1px;">
				<table class="table table-bordered" style="margin: 0;">
					<thead>
						<tr>
							<th colspan="6" class="td-center h3">
								Afiliados
								<!-- <i (click)="createAffiliate()" placement="bottom" tooltip="Crea un afiliado" class="clickeable fa fa-plus text-success"></i> -->
								<div class="input-group">
									<label for="filter" class="input-group-text">
										Buscar
									</label>
									<input type="text" (input)="filterAffiliates()" placeholder="Buscar por código/nombre/NIT" [(ngModel)]="filterAffiliate" class="form-control">
								</div>
							</th>
						</tr>
						<tr>
							<th class="td-center">
								Afiliado
							</th>
							<th>
								Nombre
							</th>
							<th>
								NIT
							</th>
							<th>
								Código
							</th>
							<th class="td-center">
								Puntos
							</th>
							<th>

							</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let affiliate of pagination.filter">
							<td class="td-center">
								<i *ngIf="!converting[affiliate.id]" tooltip="Activa/Desactiva estado del afiliado"
									(click)="convert(affiliate)"
									[ngClass]="affiliate.active?'fa-toggle-on text-success a-hover':'fa-toggle-off'"
									class="fa active clickeable"></i>
								<span *ngIf="converting[affiliate.id]"
									[ngClass]="affiliate.active?'text-secondary':'text-success'"
									class="spinner-border spinner-border-sm"></span>
							</td>
							<td>
								{{affiliate.nombre}}
							</td>
							<td>
								{{affiliate.nit}}
							</td>
							<td>
								{{affiliate.code}}
							</td>
							<td class="td-center">
								{{affiliate.points}}
							</td>
							<td class="td-center">
								<i class="fa clickeable text-info fa-edit" (click)="edit(affiliate)"></i>
							</td>
						</tr>
						<tr *ngIf="pagination.filter.length == 0">
							<td colspan="5" class="td-center">
								<i class="fa fa-circle-info"></i>
								{{affiliates.length == 0?'Aún no se han agregado afiliados':'No se encuentran ' +
								'resultados para '}}
								<b>{{affiliates.length > 0 && filterAffiliate?filterAffiliate:''}}</b>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<app-pagination-custom [elements]="pagination"></app-pagination-custom>
		</ng-container>
		<ng-container *ngIf="selected == 'events'">
			<div class="table-responsive" style="margin-top: -1px;">
				<table class="table table-bordered" style="margin: 0;">
					<thead>
						<tr>
							<th colspan="5" class="td-center h3">
								Eventos	
								<i placement="bottom" tooltip="Crear evento" class="clickeable text-success fa fa-plus" (click)="modalEventShowing = true"></i>
							</th>
						</tr>
						<tr>
							<th class="td-center">
								Activo
							</th>
							<th>
								Nombre
							</th>
							<th class="td-center">
								Fecha Inicio
							</th>
							<th class="td-center">
								Fecha Final
							</th>
							<th class="td-center">
								Multiplicador
							</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let event of paginationEvents.filter">
							<td class="td-center">
								<i *ngIf="!updatingEvent[event.id]" tooltip="Activa/Desactiva el evento"
									(click)="updateEvent(event)"
									[ngClass]="event.active?'fa-toggle-on text-success a-hover':'fa-toggle-off clickeable'"
									class="fa active"></i>
								<span *ngIf="updatingEvent[event.id]"
									[ngClass]="event.active?'text-secondary':'text-success'"
									class="spinner-border spinner-border-sm"></span>
							</td>
							<td>
								{{event.nombre}}
							</td>
							<td class="td-center">
								{{event.startDate | date:'dd/MM/YYYY'}}
							</td>
							<td class="td-center">
								{{event.endDate | date:'dd/MM/YYYY'}}
							</td>
							<td class="td-center">
								{{event.multiplier}}
							</td>
						</tr>
						<tr *ngIf="paginationEvents.filter.length == 0">
							<td colspan="5" class="td-center">
								<i class="fa fa-circle-info"></i>
								{{events.length == 0?'Aún no se han agregado afiliados':'No se encuentran ' +
								'resultados para '}}
								<b>{{events.length > 0 && filterAffiliate?filterAffiliate:''}}</b>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<app-pagination-custom [elements]="paginationEvents"></app-pagination-custom>
		</ng-container>
		<ng-container *ngIf="selected == 'historical'">
			<app-affiliate-points-historical/>
		</ng-container>
	</div>
</div>
<app-modal-create-affiliate *ngIf="modalAffiliateShowing" [isCreating]="isCreatingAffiliate" [affiliate]="affiliateEditing"
	(close)="close($event)"></app-modal-create-affiliate>
<app-modal-schema-point *ngIf="modalSchemaShowing" (close)="closeModalSchema($event)"></app-modal-schema-point>
<app-modal-affiliate-event *ngIf="modalEventShowing" (close)="closeModalEvent($event)"></app-modal-affiliate-event>